import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["content", "summary", "turboStream"]
  declare readonly contentTarget: HTMLElement
  declare readonly summaryTarget: HTMLElement

  static values = {
    open: { type: Boolean, default: false }
  }
  declare openValue: boolean

  turboStreamTargetConnected(): void {
    this.open()
  }

  openValueChanged(): void {
    this.contentTarget.style.marginTop = this.openValue
      ? `-${this.summaryTarget.scrollHeight}px`
      : "0px"

    if (this.openValue) {
      this.dispatch("open", { detail: { drawer: this } })
    }
  }

  afterTransition(callback: () => void): void {
    const onTransitionEnd = (): void => {
      callback()
      this.contentTarget.removeEventListener("transitionend", onTransitionEnd)
    }

    this.contentTarget.addEventListener("transitionend", onTransitionEnd)
  }

  close(): void {
    this.openValue = false
  }

  open(): void {
    this.openValue = true
  }
}
